import React, { useMemo } from 'react'
import { observer } from 'mobx-react';

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  IconButton,
} from "@chakra-ui/react"
import { useStores } from 'hooks/useStores';
import * as yup from 'yup';
import { useForm, FormProvider } from 'react-hook-form';
import { API_ROUTES, botApi } from '_app/api';
import { Input, Switch } from 'components/Form';
import { yupResolver } from '@hookform/resolvers/yup';

const schema = yup.object().shape({
  roomId: yup.string().required(),
  isFast: yup.bool(),
  fakeGuest: yup.bool(),
});


const AddBotModal = ({ isOpen, onClose }) => {
  const { botsStore: { fetchData} } = useStores();

  const methods = useForm({
    resolver: yupResolver(schema)
  });

  const onSubmit = async (data) => {
    await botApi.post(API_ROUTES.bots.join, {
      ...data
    });

    fetchData();

    onClose();
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="3xl" closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Add bots</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(onSubmit)} id="add-bot-form">
              <Input name="roomId" label="Room ID" />
              <Switch name="isFast" label="normal / fast" />
              <Switch name="fakeGuest" label="bot name / guest name" />
            </form>
          </FormProvider>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={onClose}>
            Close
          </Button>
          <Button colorScheme="blue" variant="solid" mr={3} type="submit" form="add-bot-form">
            Add
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default observer(AddBotModal);
